module.exports = __webpack_public_path__ + "img/content4-5.d7a4b5bd.png";